import { INIT_PERSON, UPDATE_BROKER_ID, CANCEL_IMPERSONATION, UNSET_PERSON } from './actions';

export const initialState = () => {
    return {
        id: null,
        brokerId: null,
        isUnderwriter: false,
    };
};

/**
 * Person
 *
 * Helps with situation when user act in behalf of other person and as such
 * assign properties that normally don't belong to him as his own.
 * In our application such role belong only to user known as underwriter.
 *
 * @param {} initialState
 * @returns {}
 */
const person = (state = initialState(), action) => {
    const { type, value, payload } = action;

    switch (type) {
        case INIT_PERSON:
            return { ...state, ...payload };
        case UPDATE_BROKER_ID:
            if (!state.isUnderwriter) return state
            return { ...state, brokerId: value.brokerId }
        case CANCEL_IMPERSONATION:
            if (!state.isUnderwriter) return state
            return { ...state, brokerId: null }
        case UNSET_PERSON:
            return initialState()
        default:
            return state;
    }
};

export default person;
